import React from "react"
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import MDInput from "materialDashboard/components/MDInput";


const Notes = ({formik, inputDisabled}) => {
    const {t} = useTranslation(['models1']);

    // a text input for the notes
    return <Grid container rowSpacing={3} columnSpacing={4}>
        <Grid item xs={12}>
            <MDInput label={t('model1Form.notes')}
                     multiline
                     rows={4}
                     fullWidth
                     disabled={inputDisabled}
                     {...formik.getFieldProps('notes')}
            />
        </Grid>
    </Grid>
}

export default Notes;